<template>
    <b-card> 

        <b-form>

            <div class="animated fadeIn">

                <b-row>
                    <b-col md="12">
                    <b-form>
                        <b-form-group
                        description="Local do código fonte dos arquivos"
                        label="Pasta do Código Fonte"
                        label-for="sourceModelFolder"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-input v-model="ca.sourceModelFolder" id="sourceModelFolder" type="text" placeholder="Ex: d:/devrastrea/smgws/src/main/resources"></b-form-input>
                    </b-form-group> 
                    </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                    <b-form>
                        <b-form-group
                        description="Sub-pasta em Pasta do Código Fonte: cleanarch_no_page | cleanarch"
                        label="Código Fonte"
                        label-for="sourceModelCode"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-input v-model="ca.sourceModelCode" id="sourceModelCode" type="text" placeholder="Ex: cleanarch"></b-form-input>
                    </b-form-group> 
                    </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                    <b-form>
                        <b-form-group
                        description="Caminho onde serão ferados os arquivos"
                        label="Caminho do Fonte"
                        label-for="sourcePath"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-input v-model="ca.sourcePath" id="sourcePath" type="text" placeholder="Ex: D:/devrastrea/smgws/src/main/java"></b-form-input>
                    </b-form-group> 
                    </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                    <b-form>
                        <b-form-group
                        description="Ex: br.com.a6i.smgws"
                        label="Nome do Pacote"
                        label-for="packageName"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-input v-model="ca.packageName" id="packageName" type="text" placeholder="br.com.a6i.smgws"></b-form-input>
                    </b-form-group> 
                    </b-form>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                    <b-form>
                        <b-form-group
                        description=""
                        label="Objeto do Pacote"
                        label-for="packageObject"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-input v-model="ca.packageObject" id="packageObject" type="text" placeholder="system"></b-form-input>
                    </b-form-group> 
                    </b-form>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                    <b-form>
                        <b-form-group
                        description="Nome da classe (entidade)"
                        label="Nome da Classe"
                        label-for="className"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-input v-model="ca.className" id="className" type="text" placeholder=""></b-form-input>
                    </b-form-group> 
                    </b-form>
                    </b-col>
                </b-row>
                
            
                <b-row>
                    <b-col md="12">
                    <b-form>
                        <b-form-group
                        description="Ex: Long | Integer | String"
                        label="Tipo da Coluna (id)"
                        label-for="idColumnType"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-input v-model="ca.idColumnType" id="idColumnType" type="text" placeholder=""></b-form-input>
                    </b-form-group> 
                    </b-form>
                    </b-col>
                </b-row>

                <hr>

                <b-row>
                    <b-col md="12">
                    
                        <b-form-group
                        description=""
                        label=""
                        label-for="createDTO"
                        :label-cols="3"
                        :horizontal="true">
                        <input id="createDTO" type="checkbox" v-model="ca.createDTO"> DTO
                        </b-form-group>          

                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                    
                        <b-form-group
                        description=""
                        label=""
                        label-for="createConverter"
                        :label-cols="3"
                        :horizontal="true">
                        <input id="createConverter" type="checkbox" v-model="ca.createConverter"> Converter
                        </b-form-group>          

                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                    
                        <b-form-group
                        description=""
                        label=""
                        label-for="createService"
                        :label-cols="3"
                        :horizontal="true">
                        <input id="createService" type="checkbox" v-model="ca.createService"> Service
                        </b-form-group>          

                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                    
                        <b-form-group
                        description=""
                        label=""
                        label-for="createRepository"
                        :label-cols="3"
                        :horizontal="true">
                        <input id="createRepository" type="checkbox" v-model="ca.createRepository"> Repository
                        </b-form-group>          

                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                    
                        <b-form-group
                        description=""
                        label=""
                        label-for="createPageRepository"
                        :label-cols="3"
                        :horizontal="true">
                        <input id="createPageRepository" type="checkbox" v-model="ca.createPageRepository"> PageRepository
                        </b-form-group>          

                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                    
                        <b-form-group
                        description=""
                        label=""
                        label-for="createController"
                        :label-cols="3"
                        :horizontal="true">
                        <input id="createController" type="checkbox" v-model="ca.createController"> Controller
                        </b-form-group>          

                    </b-col>
                </b-row>



                <b-row>
                    <b-col md="12">
                    
                        <b-form-group
                        description=""
                        label=""
                        label-for="createFiles"
                        :label-cols="3"
                        :horizontal="true">
                        <input id="createFiles" type="checkbox" v-model="ca.createFiles"> Criar Arquivos
                        </b-form-group>          

                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                    
                        <b-form-group
                        description=""
                        label=""
                        label-for="replaceFiles"
                        :label-cols="3"
                        :horizontal="true">
                        <input id="replaceFiles" type="checkbox" v-model="ca.replaceFiles"> Substituir Arquivos
                        </b-form-group>          

                    </b-col>
                </b-row>
                    
                <b-input-group class="mb-4">
                    <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
                </b-input-group>
                
            </div>
        </b-form>

        <div slot="footer" class="text-right">
            <b-button variant="github" class="mr-1 btn-brand" @click="createCleanArchitecture()"><i class="fa fa-check"></i><span>Criar Classes</span></b-button>
        </div>
            
    </b-card>
</template>


<script>
import Vue from 'vue'
import axios from "axios";


/* Toast */
import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */


export default {
    name: 'documentModelPdfComponent',
    props: {
       
    },
    components: {
       
    },
    data: () => {
        return {
            errorMessage: '',
            ca: {
                sourceModelFolder: 'C:/dev/smgws/src/main/resources',
                sourceModelCode: 'cleanarch_no_page',

                sourcePath: 'C:/dev/smgws/src/main/java',
                packageName: 'br.com.a6i.smgws',
                packageObject: 'sys',
                className: '',
                idColumnType: 'Long',

                createDTO: true,
                createConverter: true,
                createService: true,
                createRepository: true,
                createPageRepository: false,
                createController: true,

                createFiles: true,
                replaceFiles: false
            }
        }
    },
    methods: {
        async postCleanArchitecture() {
            
            var s = this;
            var currentUser = this.$store.state.currentUser;
          
            var postData = {...this.ca};
            postData.uid = currentUser.id
            postData.sid = currentUser.sid

            console.log(postData)
            
            await axios.post(
                this.$store.state.ws_url + "/dev/createclasses",
                postData
            ).then(function(resp) {
                console.log(resp)   
                s.errorMessage = 'Classes criadas com sucesso'             
            })            
            .catch(function(error) {
                console.log(error)
                s.errorMessage = 'Erro ao criar classes: '
            });
            
        },
        createCleanArchitecture() {
            if(this.ca.sourceModelCode && this.ca.sourceModelFolder && this.ca.sourcePath && this.ca.className && this.ca.packageName && this.ca.idColumnType) {
                this.postCleanArchitecture();
                this.errorMessage = ''
            }
            else {
                this.errorMessage = 'Favor preencher os campos obrigatórios.'
                toast ({
                    type: VueNotifications.types.error,
                    title: 'Clean Architecture',
                    message: 'Favor preencher os campos obrigatório.',
                    timeout: 3000
                })
            }
        },
    }
}
</script>